//
// Copyright (c) 2008-2025 Barry E. Mapen All Rights Reserved
//
import axios from 'axios';
//import { useAuth } from '../../auth';

export const cacheName = 'choice-service';

export var choiceSignout = () => console.warn(`Signout function not set yet - this needs to be done early during initialization prior to making calls`)

export function setChoiceSignout(signout) {
    choiceSignout = signout;
}

//
// For each API we have, we need to create a unique Axios instance
//  which will set the baseURL for all relative URL calls, ensure CORS
//  (withCredentials) is set on every call, and will automatically 
//  get or refresh accessTokens as necessary
//
var choiceService = axios.create({
    withCredentials: true,
    baseURL: process.env.REACT_APP_CHOICE_API_URL,
})



//
// This function will be called after to every response is received before 
//  it passes back to the original caller.  If we failed because we are attempting
//  to access a URL and it tells us we're not authorized (401 - not logged in) 
//  instead of forbidden (403 - authorized user, but you're not allowed to do this)
//  then we need to declare the user as signed out so they are prompted to login
//
choiceService.interceptors.response.use(
    // When things are working fine, just pass the responses through
    function (response) {
        return response;
    }, 

    // When there are problems...
    function (error) {
        // If the request is rejected for an expired token, we should try to 
        //  refresh the token and automatically try the request again, but we 
        //  should not do anything if this is a login 401 problem
        if ( (error.response.status === 401) && !(error.config.url.includes('login')) ) {
            console.log(`unauthorized response code intercepted - auto signout`)
            choiceSignout();
        }

        // Regardless, we should return the error and let the application/user
        //  decide what to do
        return Promise.reject({...error});
    }
);



export default choiceService;